export type CompanySyncPropertyType = 'string' | 'enumeration' | 'bool' | 'number';
export type CompanySyncRuleOperator = 'equals' | 'not_equals' | 'in' | 'not_in' | 'contains' | 'starts_with' |
  'ends_with' | 'gt' | 'gte' | 'lt' | 'lte' | 'known' | 'unknown';
export interface CompanySyncCondition {
  propertyName: string;
  propertyType: CompanySyncPropertyType;
  operator: CompanySyncRuleOperator;
  values: string[];
}
export interface CompanySyncEligibility {
  version: 1;
  mode: 'all' | 'matching';
  groups: Array<{conditions: CompanySyncCondition[]}>;
}
export interface CompanySyncEligibilityPreview {
  schemaVersion: 'company-sync-eligibility-preview.v1';
  policyRevision: string;
  sampled: true;
  pageSize: number;
  counts: {eligible: number; excluded: number; pending: number; invalid: number};
  items: Array<{id: string; name: string; decision: 'eligible' | 'excluded' | 'pending' | 'invalid'}>;
  nextCursor: string | null;
  webhookCoverageMissing: string[];
}
export const allCompaniesPolicy = (): CompanySyncEligibility => ({version: 1, mode: 'all', groups: []});
